import TextIcon from './board-select-icons/text-icon';
import NumberIcon from './board-select-icons/number-icon';
import PersonIcon from './board-select-icons/person-icon';
import DropdownIcon from './board-select-icons/dropdown-icon';
import TagsIcon from './board-select-icons/tags-icon';
import LocationIcon from './board-select-icons/location-icon';
import LinkIcon from './board-select-icons/link-icon';
import EmailIcon from './board-select-icons/email-icon';
import LongTextIcon from './board-select-icons/long-text-icon';
import PhoneIcon from './board-select-icons/phone-icon';

export const boardSelectTypes = {
  location: LocationIcon,
  link: LinkIcon,
  email: EmailIcon,
  text: TextIcon,
  name: TextIcon,
  'long-text': LongTextIcon,
  numeric: NumberIcon,
  phone: PhoneIcon,
  'multiple-person': PersonIcon,
  dropdown: DropdownIcon,
  tag: TagsIcon,
};
